import {IRutubeProps} from 'components/VideoRutube/type';

export const getVideoId = (url: IRutubeProps['url']) => {
    const urlObj = new URL(url);
    const pathnameParts = urlObj.pathname.split('/');

    return pathnameParts[pathnameParts.findIndex((item) => 'video' === item) + 1];
};
